import { render, staticRenderFns } from "./assetModal.vue?vue&type=template&id=12879c44&scoped=true"
import script from "./assetModal.vue?vue&type=script&lang=js"
export * from "./assetModal.vue?vue&type=script&lang=js"
import style0 from "./assetModal.vue?vue&type=style&index=0&id=12879c44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12879c44",
  null
  
)

export default component.exports